<script setup lang="ts">
import BaseBanner from './base/BaseBanner.vue'
import { useGiveaway } from '@/composables/game/giveaway'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
  pulsate?: boolean
  isSingle?: boolean
  hasTag?: boolean
}>(), {
  pulsate: false,
  isSingle: false,
  hasTag: true,
})

const { countdown } = useGiveaway()
</script>

<template>
  <div :class="twMerge(isSingle && 'banner-container')">
    <BaseBanner
      :pulsate="pulsate"
      :show-live-chip="hasTag"
      live-chip-variant="dynamic"
      :live-chip-status="!!countdown"
    >
      <div class="flex items-center justify-center w-full h-full">
        <img
          class="w-full h-full object-cover"
          src="@/assets/images/banners-s2/lucky-rush-banner.webp"
        >
      </div>
    </BaseBanner>
  </div>
</template>

<style scoped>
.gradient-border-image {
  border-radius: 12px;
  background-image: url("@/partners/lingo/lingo-giveaway/assets/images/lingo-banner.png");
}

.banner-title {
  filter: drop-shadow(0px 0px 10.433px rgba(0, 0, 0, 0.66));
}

.ticket-transform {
  transform: translate(-50%, -50%) rotate(-22deg);
}

/* .banner-container {
  background: linear-gradient(
    90.15deg,
    rgba(99, 91, 255, 0.1) -8.43%,
    rgba(220, 65, 251, 0.1) 83.79%,
    rgba(255, 112, 150, 0.1) 97.59%
  );
  border-radius: 13px;
} */
</style>
